export const TKeyFooter = {} as const;
